import { type JSX, type ReactNode, createContext, use } from 'react'

/**
 * How much taller a chart draws than its desk size.
 *
 * The console has no provider, so a chart there draws at 1. The TV canvas
 * provides the growth that still lets its page fit.
 */
const ChartGrowContext = createContext(1)

/**
 * The growth a chart draws at.
 *
 * @returns 1 on the console. On a TV, the canvas's growth.
 */
export function useChartGrow(): number {
  return use(ChartGrowContext)
}

/**
 * Give the charts below a growth.
 *
 * @param props - Provider props.
 * @param props.grow - The growth, 1 or more.
 * @param props.children - The page.
 * @returns The provider.
 */
export function ChartGrowProvider({
  grow,
  children
}: {
  grow: number
  children: ReactNode
}): JSX.Element {
  return <ChartGrowContext value={grow}>{children}</ChartGrowContext>
}
